import { useConfidenceFlagContext } from '@/hooks/useConfidenceFlag';
import { ReactNode } from 'react';

interface ConfidenceFlagWrapperProps<T> {
  children: (flagValue: T) => ReactNode;
  loadingPlaceholder?: ReactNode;
}

export function ConfidenceFlagWrapper<T = any>({ children, loadingPlaceholder = null }: ConfidenceFlagWrapperProps<T>) {
  const { flagValue, isReady } = useConfidenceFlagContext<T>();

  if (!isReady) {
    return <>{loadingPlaceholder}</>;
  }

  return <>{children(flagValue)}</>;
}
